/** Our application contract, not Codex's raw error schema. */
export interface AgentProblem {
  reasonCode: string;
  message: string;
  availableActions: ('sign_in' | 'open_settings')[];
  diagnosticId?: string;
}

export function parseAgentProblem(value: unknown): AgentProblem | undefined {
  if (!value || typeof value !== 'object') return undefined;
  const candidate = value as Record<string, unknown>;
  if (typeof candidate['reasonCode'] !== 'string' || typeof candidate['message'] !== 'string') return undefined;
  const actions = Array.isArray(candidate['availableActions']) ? candidate['availableActions'] : [];
  const diagnosticId = candidate['diagnosticId'];
  return {
    reasonCode: candidate['reasonCode'],
    message: candidate['message'],
    availableActions: actions.filter((a): a is 'sign_in' | 'open_settings' => a === 'sign_in' || a === 'open_settings'),
    diagnosticId: typeof diagnosticId === 'string' && /^[a-f0-9]{32}$/.test(diagnosticId) ? diagnosticId : undefined,
  };
}
